import { Component } from '@angular/core';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { TeamPermissionsComponent } from '../../../shared/team-permissions/team-permissions.component';
import { WatchAccountService } from '../../../../services/watch-account.service';
import { Subscription, Observable } from 'rxjs';
import { AccountService } from '../../../../services/account.service';
import { IAccount, IProfile } from '../../../../interfaces/graph-types';
import { WatchOrganizationService } from '../../../../services/watch-organization.service';

@Component({
  selector: '[account-team]',
  template: require('./account-team.component.pug'),
  styles: [require('./account-team.component.css').toString()],
})
export class AccountTeamComponent {
  bsModalRef: BsModalRef;

  subscription: Subscription;
  account: IAccount;
  members$: Observable<IProfile[]>;

  orgId: string = null;

  // -------------------------------------------------------------------
  constructor(
    private modalService: BsModalService,
    private watchAccountService: WatchAccountService,
    private accountService: AccountService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.orgId = this.watchAccountService.accountId().getValue();

    this.subscription = this.accountService
      .getAccountInfo(this.watchAccountService.accountId().getValue())
      .subscribe(res => {
        this.account = res;
      });

    this.members$ = this.accountService.teamMembers(
      this.watchAccountService.accountId().getValue(),
    );
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  openModalWithComponent() {
    this.watchAccountService.accountId().subscribe(response => {
      const options: ModalOptions = new ModalOptions();
      options.class = 'gray modal-lg';
      options.ignoreBackdropClick = true;
      options.initialState = {
        org_id: 0, //response.organization.id,
      };

      this.bsModalRef = this.modalService.show(
        TeamPermissionsComponent,
        options,
      );
      this.bsModalRef.content.closeBtnName = 'Close';
    });
  }
}
